import React from "react";
import AllCustomers from "./CustomerModule/AllCustomers";

const Customers = () => {
  return (
    <div>
      <AllCustomers />
    </div>
  );
};

export default Customers;
